export default __webpack_public_path__ + "static/media/joshua-stannard.a16f281c.jpg";